module.exports = __webpack_public_path__ + "static/img/img-about_fc.495f45b2.png";